export class VMwareProducts {
    public id: number;
    public displayName: String;
    public rmVmwProductId: number;
    public rmVmwProduct: String;
    public cmPublishDate: Date;
    public support: boolean;
    public decription: String;
    public lastUpdate: number;
    public updatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/models/vmwareproducts.ts